import { useFeatureFlag } from 'src/integrations/feature-flags/feature-flags';
import { LegacyFeedbackButton } from './LegacyFeedbackButton';
import { PanelFeedbackButton } from './PanelFeedbackButton';

/**
 * The sidebar "Send feedback" entry. Behind the `feedback-triage-enabled` flag it opens
 * the docked feedback panel that persists reports to the dashboard; with
 * the flag off it is the original modal that only emails support through
 * `core.uiBugReport.submit`. Both keep the same menu position, label, and
 * ⌘⇧F shortcut.
 */
export function FeedbackButton() {
  const { enabled } = useFeatureFlag('feedback-triage-enabled', false);
  return enabled ? <PanelFeedbackButton /> : <LegacyFeedbackButton />;
}
